export const ROOT = document;
export const BODY = ROOT.body;
export const HTML = ROOT.documentElement;

export const BUTTON = 'button';
export const SVG = 'svg';

export const OPEN = 'open';
export const CLOSE = 'close';
export const COLOR = 'color';
export const CLICK = 'click';
export const MOUSE_DOWN = 'mousedown';
export const MOUSE_MOVE = 'mousemove';
export const MOUSE_UP = 'mouseup';
export const TOUCH_START = 'touchstart';
export const TOUCH_MOVE = 'touchmove';
export const TOUCH_END = 'touchend';
export const TOUCH_CANCEL = 'touchcancel';
export const SCROLL = 'scroll';
export const RESIZE = 'resize';
export const KEY_DOWN = 'keydown';
export const INPUT = 'input';
export const CHANGE = 'change';
export const MOUSE_LEAVE = 'mouseleave';
export const FOCUS_IN = 'focusin';
export const FOCUS_OUT = 'focusout';

export const HEX_FORMAT = 'hex';
export const RGB_FORMAT = 'rgb';
export const HSL_FORMAT = 'hsl';
export const HSV_FORMAT = 'hsv';

export const TAB = 'Tab';
export const ARROW_RIGHT = 'ArrowRight';
export const ARROW_LEFT = 'ArrowLeft';
export const ARROW_UP = 'ArrowUp';
export const ARROW_DOWN = 'ArrowDown';
export const ENTER = 'Enter';
export const ESCAPE = 'Escape';

export const FOCUS_CLASSNAME = 'tw-focus';
export const BUTTON_CLASSNAME = 'tw-btn';

export const COLOR_PROPERTY = 'tw-' + COLOR;

export const REMOVE_METHOD = 'remove';
export const ADD_METHOD = 'add';

// Picker supported color formats.
export const COLOR_FORMATS = [HEX_FORMAT, RGB_FORMAT, HSL_FORMAT];


export const { max, min, round } = Math;
export const float = parseFloat;
export const int = parseInt;